export const Modules = {
  HOME: 1,
  SCHEDULE: 42,
  DOCUMENTS: 2,
  ORGANIZATION: 3,
  COMPETITION: 4,
  PROJECT: 5,
  PARTICIPATION: 6,
  PARTICIPANT: 7,
  INVITATION_LETTER: 8,
  VIP: 9,
  FINALIST: 12,
  USER: 10,
  PAYMENT: 11,
  LOGGER: 13,
  RANKING: 29,
};
// 0:{Id: 1, PermissionId: 1, PermissionName: 'DEFAULT', Description: 'Home - Default'}
// 1:{Id: 2, PermissionId: 2, PermissionName: 'VIEW', Description: 'Home - View'}
// 2:{Id: 8, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Dropdown & Approve Permission'}
// 3:{Id: 131, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Report Summary View'}
// 4:{Id: 132, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Approval Waiting Payments Approve'}
// 5:{Id: 133, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Approval Waiting Payments View'}
// 6:{Id: 134, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Approval Waiting Juries Approve'}
// 7:{Id: 135, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Approval Waiting Juries View'}
// 8: {Id: 136, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Router Link View'}
// 9: {Id: 170, PermissionId: 0, PermissionName: 'Bilinmeyen İzin', Description: 'Home - Jury'}
export const Permissions = {
  DEFAULT: 1,
  VIEW: 2,
  ADD: 3,
  UPDATE: 4,
  DELETE: 5,
  BULK: 6,
  PRINT: 7,
  HOMEMODULE_DROPDOWN_APPROVAL: 8,
  HOMEMODULE_REPORT_SUMMARY_VIEW: 131,
  HOMEMODULE_APPROVAL_WAITING_PAYMENTS_APPROVE: 132,
  HOMEMODULE_APPROVAL_WAITING_PAYMENTS_VIEW: 133,
  HOMEMODULE_APPROVAL_WAITING_JURIES_APPROVE: 134,
  HOMEMODULE_APPROVAL_WAITING_JURIES_VIEW: 135,
  HOMEMODULE_ROUTER_LINK_VIEW: 136,
  HOMEMODULE_JURY: 170,
  HOMEMODULE_CREATE_NOTIFICATION: 279,
  PROJECTMODULE_SET_AS_FINALIST: 37,
  PROJECTMODULE_UPDATE_FINALIST_PROJECT: 137,
  // Document module specific permissions - using special permission IDs
  DOCUMENTS_JUDGE_FILES: 171,
  DOCUMENTS_COMPETITION_FILES: 172,
  // Payment module specific permissions
  PAYMENT_DEFER: 75,
  // Judgement Evaluation module specific permissions
  JUDGEMENT_EVALUATION_SELECT_JUDGE: 267,
};

// Role ID constants for easy access
export const ROLE_IDS = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  SUPERVISOR: 3,
  AFFILIATED: 4,
  JUDGE: 5,
  STUDENT: 6,
  PARENT: 7,
  GUEST: 8,
  OBSERVER: 9,
  RELATIVE: 10,
};

// Judgment Type constants
export const JUDGMENT_TYPES = {
  ONLINE: 1,
  FACE_TO_FACE: 2,
};

export const BASE_API_PATH = '/api';

export const unAuthenticatedSwrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

export const authenticatedSwrOptions = {
  revalidateIfStale: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
};

// [
//   {
//     "SortId": 1,
//     "Name": "Super Admin",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 1
//   },
//   {
//     "SortId": 2,
//     "Name": "Admin",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 2
//   },
//   {
//     "SortId": 3,
//     "Name": "Supervisor",
//     "Description": null,
//     "IsParticipant": true,
//     "Id": 3
//   },
//   {
//     "SortId": 4,
//     "Name": "Affiliated",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 4
//   },
//   {
//     "SortId": 5,
//     "Name": "Judge",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 5
//   },
//   {
//     "SortId": 6,
//     "Name": "Student",
//     "Description": null,
//     "IsParticipant": true,
//     "Id": 6
//   },
//   {
//     "SortId": 7,
//     "Name": "Parent",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 7
//   },
//   {
//     "SortId": 8,
//     "Name": "Guest",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 8
//   },
//   {
//     "SortId": 9,
//     "Name": "Observer",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 9
//   },
//   {
//     "SortId": 10,
//     "Name": "Relative",
//     "Description": null,
//     "IsParticipant": false,
//     "Id": 10
//   }
// ],
export const ROLES = [
  {
    SortId: 1,
    Name: 'Super Admin',
    Description: null,
    IsParticipant: false,
    Id: 1,
    Color: 'error',
  },
  {
    SortId: 2,
    Name: 'Admin',
    Description: null,
    IsParticipant: false,
    Id: 2,
    Color: 'warning',
  },
  {
    SortId: 3,
    Name: 'Supervisor',
    Description: null,
    IsParticipant: true,
    Id: 3,
    Color: 'secondary',
  },
  {
    SortId: 4,
    Name: 'Affiliated',
    Description: null,
    IsParticipant: false,
    Id: 4,
    Color: 'info',
  },
  {
    SortId: 5,
    Name: 'Judge',
    Description: null,
    IsParticipant: false,
    Id: 5,
    Color: 'info',
  },
  {
    SortId: 6,
    Name: 'Student',
    Description: null,
    IsParticipant: true,
    Id: 6,
    Color: 'success',
  },
  {
    SortId: 7,
    Name: 'Parent',
    Description: null,
    IsParticipant: false,
    Id: 7,
    Color: 'primary',
  },
  {
    SortId: 8,
    Name: 'Guest',
    Description: null,
    IsParticipant: false,
    Id: 8,
    Color: 'success',
  },
  {
    SortId: 9,
    Name: 'Observer',
    Description: null,
    IsParticipant: false,
    Id: 9,
    Color: 'default',
  },
  {
    SortId: 10,
    Name: 'Relative',
    Description: null,
    IsParticipant: false,
    Id: 10,
    Color: 'default',
  },
];

// Helper functions for role checking
export const RoleHelpers = {
  // Get role info by id
  getRoleById: (roleId) =>
    ROLES.find((role) => role.Id === roleId) || { Id: roleId, Name: 'Unknown', Color: 'default' },

  // Get role info by name
  getRoleByName: (roleName) =>
    ROLES.find((role) => role.Name.toLowerCase() === roleName?.toLowerCase()) || null,

  // Check if user has specific role by id
  hasRole: (user, roleId) => user?.Role?.Id === roleId,

  // Check if user has role by name (for backward compatibility)
  hasRoleName: (user, roleName) => {
    const role = RoleHelpers.getRoleByName(roleName);
    return role ? user?.Role?.Id === role.Id : false;
  },

  // Check if user is admin (Super Admin or Admin)
  isAdmin: (user) => {
    const adminRoles = [ROLE_IDS.SUPER_ADMIN, ROLE_IDS.ADMIN];
    return adminRoles.includes(user?.Role?.Id);
  },

  // Check if user is super admin
  isSuperAdmin: (user) => user?.Role?.Id === ROLE_IDS.SUPER_ADMIN,

  // Check if user is judge
  isJudge: (user) => user?.Role?.Id === ROLE_IDS.JUDGE,
};
